/**
 * The release number for the whole system, in the owner's scheme:
 *
 *   Major.Minor.SecurityStability
 *
 *   Major  a big change in how Crave works or looks.
 *   Minor  a new feature or a visible improvement.
 *   SecurityStability  security and stability work: fixes, hardening, no new features.
 *
 * `npm run release <major|minor|fix> "what changed"` writes this file, package.json and
 * CHANGELOG.md, then commits and tags. Never edit it by hand.
 */
export const RELEASE = '1.6.3';
